export enum ExpeditionProcessStatusEnum {
  PENDING_QUOTE = "PENDING_QUOTE",
  PENDING_QUOTE_ACCEPTATION = "PENDING_QUOTE_ACCEPTATION",
  PENDING_CUSTOMER = "PENDING_CUSTOMER",
  PENDING_PELICAN = "PENDING_PELICAN",
  VALIDATED = "VALIDATED",
  DELETED = "DELETED",
}

export const PRE_FINALIZATION_STATUSES: ExpeditionProcessStatusEnum[] = [
  ExpeditionProcessStatusEnum.PENDING_CUSTOMER,
  ExpeditionProcessStatusEnum.PENDING_PELICAN,
  ExpeditionProcessStatusEnum.PENDING_QUOTE,
  ExpeditionProcessStatusEnum.PENDING_QUOTE_ACCEPTATION,
];
